import { render } from "./ShippingCorrectDialog.vue?vue&type=template&id=28077fb4"
import script from "./ShippingCorrectDialog.vue?vue&type=script&lang=js"
export * from "./ShippingCorrectDialog.vue?vue&type=script&lang=js"

import "./ShippingCorrectDialog.vue?vue&type=style&index=0&id=28077fb4&lang=css"

import exportComponent from "C:\\Users\\t.chida\\Desktop\\hybrid_inventory_baroque\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__